import React, { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

export const DiamondsScoreIcon = forwardRef((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref} viewBox="0 0 74 50" data-fill-none>
      <circle cx="34" cy="25" r="17" fill="white" />
      <path
        d="M38.7615 19.0547H29.5872L25 23.8165L34.1744 33.9353L43.3487 23.8165L38.7615 19.0547Z"
        fill="#DAE5FD"
      />
      <path d="M25 23.8165H29.5872V19.0547L25 23.8165Z" fill="#CDDBF9" />
      <path
        d="M38.7622 19.0547V23.8165H29.5879L34.175 33.9353L43.3494 23.8165L38.7622 19.0547Z"
        fill="#C3D7FD"
      />
      <path
        d="M38.7629 23.8161H43.3501L34.1758 33.9349L38.7629 23.8161Z"
        fill="#91B6FF"
      />
      <path
        d="M48.211 32.7264C48.6857 32.9884 49.2856 32.8169 49.5205 32.3283C51.365 28.4921 51.7525 24.1023 50.5882 19.9848C49.3346 15.5514 46.3833 11.7913 42.3747 9.5204C38.3661 7.24949 33.6237 6.65103 29.1766 7.8549C24.7295 9.05876 20.9366 11.9678 18.621 15.9508C16.3053 19.9337 15.6538 24.6691 16.8079 29.1294C17.9619 33.5897 20.8283 37.4149 24.7851 39.775C28.7418 42.135 33.4697 42.8395 37.9426 41.7355C42.0969 40.7101 45.72 38.2015 48.1413 34.7006C48.4497 34.2547 48.3019 33.6485 47.8394 33.3656C47.3769 33.0827 46.7751 33.2304 46.4635 33.6741C44.3144 36.735 41.1245 38.9278 37.4721 39.8293C33.5011 40.8095 29.3037 40.1841 25.7908 38.0888C22.278 35.9935 19.7332 32.5975 18.7086 28.6376C17.6841 24.6778 18.2625 20.4736 20.3183 16.9376C22.3741 13.4015 25.7415 10.8188 29.6896 9.75005C33.6378 8.68125 37.8481 9.21257 41.407 11.2287C44.9658 13.2448 47.586 16.5831 48.6989 20.519C49.7225 24.139 49.3951 27.996 47.7984 31.3781C47.567 31.8684 47.7363 32.4645 48.211 32.7264Z"
        fill="#ECF2FF"
      />
      <path
        d="M17.8256 17.4881C21.8351 8.69454 32.2141 4.81627 41.0077 8.82577C49.8012 12.8353 53.6795 23.2142 49.67 32.0078C45.6605 40.8014 35.2815 44.6797 26.4879 40.6702C17.6943 36.6607 13.8161 26.2817 17.8256 17.4881ZM47.8836 31.1933C51.4432 23.3863 48.0001 14.1719 40.1931 10.6122C32.3861 7.05255 23.1717 10.4957 19.612 18.3027C16.0524 26.1096 19.4955 35.3241 27.3025 38.8838C35.1095 42.4434 44.3239 39.0003 47.8836 31.1933Z"
        fill="#3D7FFE"
      />
      <path
        d="M59.9464 9.61849C61.6841 7.96277 62.815 5.23828 63.5 3C64.185 5.25142 65.3389 7.96277 67.0536 9.61849C68.7684 11.2742 71.6508 12.3517 74 13.0044C71.6324 13.657 68.7914 14.7565 67.0536 16.3903C65.3159 18.0241 64.185 20.7486 63.5 23C62.815 20.7486 61.6611 18.0372 59.9464 16.3815C58.2316 14.7258 55.3492 13.6483 53 12.9956C55.3676 12.343 58.2086 11.2654 59.9464 9.60972V9.61849Z"
        fill="#3D7FFE"
      />
      <path
        d="M50.3155 2.31647C50.8947 1.73697 51.2717 0.783399 51.5 0C51.7283 0.787998 52.113 1.73697 52.6845 2.31647C53.2561 2.89597 54.2169 3.27311 55 3.50153C54.2108 3.72996 53.2638 4.11476 52.6845 4.6866C52.1053 5.25843 51.7283 6.212 51.5 7C51.2717 6.212 50.887 5.26303 50.3155 4.68353C49.7439 4.10403 48.7831 3.72689 48 3.49847C48.7892 3.27004 49.7362 2.8929 50.3155 2.3134V2.31647Z"
        fill="#3D7FFE"
      />
      <path
        d="M3.63857 28.9711C4.54882 27.9777 5.1412 26.343 5.5 25C5.8588 26.3509 6.46322 27.9777 7.36143 28.9711C8.25963 29.9645 9.76948 30.611 11 31.0026C9.75985 31.3942 8.27167 32.0539 7.36143 33.0342C6.45118 34.0145 5.8588 35.6491 5.5 37C5.1412 35.6491 4.53678 34.0223 3.63857 33.0289C2.74037 32.0355 1.23052 31.389 0 30.9974C1.24015 30.6058 2.72833 29.9593 3.63857 28.9658V28.9711Z"
        fill="#3D7FFE"
      />
    </SvgIcon>
  );
});
